import { ValidationErrorData } from '../../typings/common';

export const SHOW_ERRORS_CAMPAIGN_PLACE_EDITOR = 'SHOW_ERRORS_CAMPAIGN_PLACE_EDITOR';
export type SHOW_ERRORS_CAMPAIGN_PLACE_EDITOR = typeof SHOW_ERRORS_CAMPAIGN_PLACE_EDITOR;

export interface ShowErrorsCampaignPlaceEditor {
    type: SHOW_ERRORS_CAMPAIGN_PLACE_EDITOR;
    editorId: string;
    errors: ValidationErrorData[];
}

export function showErrorsCampaignPlaceEditorAction(
    editorId: string,
    errors: ValidationErrorData[]
): ShowErrorsCampaignPlaceEditor {
    return {
        type: SHOW_ERRORS_CAMPAIGN_PLACE_EDITOR,
        editorId,
        errors
    };
}
